import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { Slide } from 'pure-react-carousel';
import CarouselSlider from 'components/atoms/TemplateCarouselSlider';
/**
 * ListButtonCarousel
 */
const ListBtnElement = ({ onClickEvt, data, styleDef }) => {
    const buttonStyle = {
        "display": "inline-block",
        "width": "100%",
        "textAlign": "left",
        fontSize: styleDef.fontSize
    }
    return (
        <button type="button" className="_list_btn_button" style={buttonStyle} onClick={e => onClickEvt(data.value, data.action, data.label)}>
            {ReactHtmlParser(data.label)}
        </button>
    );
};

const ListBtnCarousel = ({ boxStyle, item, viewType, onClickEvt }) => {
    const { items } = item;
    const slideBoxSet = boxStyle;
    const slideBoxSetStyle = {
        width: `${slideBoxSet.width}px`,
        height: slideBoxSet.height,
        margin: `0 ${slideBoxSet.margin}px`,
    };

    const slideLength = items.length;
    const constentSet = () => {
        return (
            <>
                {items.map((tempItem, idx) => {
                    // console.log(tempItem.button)
                    return (
                        <Slide key={`slide_${idx}`} index={idx} className="_list_btn_carousel" aria-roledescription="card" style={slideBoxSetStyle}>
                            <div className="_list_btn">
                                {
                                    tempItem.text.desc
                                        ? <div className="_title">
                                            <div className="_label">
                                                <div className="_label_tit" style={{fontSize: boxStyle.fontSize}}>
                                                    {ReactHtmlParser(tempItem.text.desc)}
                                                </div>
                                            </div>
                                        </div>
                                        : null
                                }
                                {tempItem.button.map((data, number) => {
                                    if (data.label) {
                                        return <ListBtnElement key={'list_btn_ele_' + number} styleDef={boxStyle} onClickEvt={onClickEvt} data={data} />;
                                    }
                                    return null;
                                })}
                            </div>
                        </Slide>
                    );
                })}
            </>
        );
    };
    return (
        <>
            <div className="_carousel_button_div _list_btn_carousel">
                <CarouselSlider slideBoxSet={slideBoxSet} contentCount={slideLength} contentSet={constentSet} />
            </div>
        </>
    );
};
ListBtnCarousel.propTypes = {
    boxStyle: PropTypes.object,
    item: PropTypes.object,
    viewType: PropTypes.string,
    onClickEvt: PropTypes.func,
};
ListBtnCarousel.defaultProps = {
    boxStyle: { width: 150, margin: 9, height: '220px' },
    item: {},
    viewType: 'advise', // advise, simulator, knowledge
    onClickEvt: null,
};
ListBtnElement.propTypes = {
    data: PropTypes.object,
    onClickEvt: PropTypes.func,
    styleDef: PropTypes.object,
};
ListBtnElement.defaultProps = {
    data: {},
    onClickEvt: null,
    styleDef: {},
};

export default ListBtnCarousel;
